import { LogoMark } from "./Logo";
import { scrollToSection, scrollToTop } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-10">
      <div className="container flex flex-col items-center justify-between gap-6 sm:flex-row">
        <button
          onClick={scrollToTop}
          data-testid="footer-logo"
          className="flex items-center gap-2.5 transition-opacity hover:opacity-85"
        >
          <LogoMark className="h-7 w-7" />
          <span className="font-display text-base font-bold tracking-tight text-slate-200">
            Gentec<span className="text-cyan-300">IT</span>
          </span>
        </button>

        <div className="text-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
            © {new Date().getFullYear()} GentecIT. All rights reserved.
          </p>
          <p
            data-testid="footer-legal-entity"
            className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500"
          >
            GENTEC IT PTY LTD · ABN: 68 627 991 548
          </p>
        </div>

        <div className="flex items-center gap-6">
          {["about", "services", "contact"].map((l) => (
            <button
              key={l}
              data-testid={`footer-link-${l}`}
              onClick={() => scrollToSection(`#${l}`)}
              className="text-xs font-medium capitalize text-slate-400 transition-colors hover:text-cyan-300"
            >
              {l}
            </button>
          ))}
          <a
            href="mailto:contact@gentecit.com"
            data-testid="footer-email-link"
            className="font-mono text-[10px] uppercase tracking-[0.18em] text-cyan-300/90 transition-colors hover:text-cyan-200"
          >
            contact@gentecit.com
          </a>
        </div>
      </div>
    </footer>
  );
}
